import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, inject, Injectable } from '@angular/core';
import { ToastService } from '../shared/services/toast.service';

@Injectable({
  providedIn: 'root',
})
export class CustomErrorHandlerService implements ErrorHandler {
  private readonly _toastService = inject(ToastService);

  public handleError(error: any): void {
    console.error(error);
    if (error instanceof HttpErrorResponse) return;
    if (error)
      this._toastService.showError(
        // ToastService translates these Dutch texts in the portal.
        'Er is een onverwachte fout opgetreden. Probeer het later opnieuw.',
        error?.title || 'Onbekende fout'
      );
  }
}
